import { Injectable } from '@angular/core';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { ApiService } from './api.service';
import { SharedService } from './shared.service';
import { Observable } from 'rxjs';
import { AllRoleListReq, Response, RoleMasterListRes, RoleMasterRequest, UserRoleDetails } from '../models';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  private api: string = CONTROLLERS.ROLEMASTER;

  constructor(
    private apiService: ApiService
  ) { }

  GetMenuListByCustomerSubscription(
    body: any
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.ROLEMASTER.GET_MENU_LIST_BY_CUSTOMER_SUBSCRIPTION}`,
      body
    );
  }

  GetRoleMasterById(
    body: any
  ): Observable<Response<UserRoleDetails>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.ROLEMASTER.GET_BY_ID}`,
      body
    );
  }

   GetRoleMasterByMember(): Observable<Response<UserRoleDetails>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.ROLEMASTER.GET_ROLEMASTER_BY_MEMBER}`,{}
    );
  }

  createRole(body: RoleMasterRequest): Observable<Response<boolean>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.ROLEMASTER.CREATE_ROLE}`, body);
  }

  updateRole(body: RoleMasterRequest): Observable<Response<boolean>> {
    return this.apiService.put('', `${this.api}/${ENDPOINTS.ROLEMASTER.UPDATE_ROLE}`, body);
  }

  getAllRoleList(
    paginationRequestCommand: AllRoleListReq
  ): Observable<Response<RoleMasterListRes>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.ROLEMASTER.LIST}`,
      paginationRequestCommand
    );
  }

  getRoleMasterDropdown(practiceId: number) {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.ROLEMASTER.ROLE_MASTER_DROPDOWN_BY_PRACTICE_ID}/${practiceId}`
    );
  }
}
